export const DEFAULT_THEME = {
    "--font-family": "Open Sans",
    "--theme-primary": "#1d2832",
    "--theme-secondary": "#fff",
    "--theme-secondary-transparent-50": "rgba(255, 255, 255, 0.5)",
    "--theme-auxiliary": "#C8CBC8",
    "--theme-additional": "#C8CBC8",
    "--theme-shade": "#0db4ac",
    "--theme-shade-transparent-50": "rgba(13, 180, 172, 0.5)",
    "--theme-tertiary": "#0db4ac",
    "--theme-tertiary-25": "rgba(13, 180, 172, 0.25)",
    "--gradient-color-1": "#283542",
    "--gradient-color-2": "#1d2832",
    "--theme-gradient-background":
        "transparent linear-gradient(148deg, #283542 0%, #1d2832 100%) 0 0 no-repeat padding-box",
    "--bg-image":
        "url('/img/backgrounds/reduxi.svg'), linear-gradient(149deg, #1d2832 0%, #1d2832  100%)",
    "--bg-image-public":
        "url('/img/backgrounds/reduxi.svg'), linear-gradient(149deg, #1d2832 0%, #1d2832  100%)",
}

export const EDITABLE_THEME_VARIABLES = [
    {
        key: "--font-family",
        label: "Font Family",
        type: "select",
        description: "Font family",
        options: ["Open Sans", "Figtree", "Archivo", "Montserrat", "Intelo"],
    },
    {
        key: "--theme-primary",
        label: "Primary Color",
        type: "color",
        description: "Primary color",
    },
    {
        key: "--theme-secondary",
        label: "Secondary Color",
        type: "color",
        description: "Secondary color",
    },
    {
        key: "--theme-tertiary",
        label: "Tertiary Color",
        type: "color",
        description: "Tertiary color",
    },
    {
        key: "--theme-shade",
        label: "Shade Color",
        type: "color",
        description: "Shade color",
    },
    {
        key: "--theme-additional",
        label: "Additional Color",
        type: "color",
        description: "Additional color",
    },
    {
        key: "--theme-auxiliary",
        label: "Auxiliary Color",
        type: "color",
        description: "Secondary light",
    },
    {
        key: "--gradient-color-1",
        label: "Gradient Start",
        type: "color",
        description: "Gradient color 1",
    },
    {
        key: "--gradient-color-2",
        label: "Gradient End",
        type: "color",
        description: "Gradient color 2",
    },
]
